var $c988ad659dbdaa8a$exports = {};
$c988ad659dbdaa8a$exports = {
    "valid": `Valide`
};


export {$c988ad659dbdaa8a$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
